import 'dayjs/locale/ko';

import { useState } from 'react';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { useGetPayInfoApi } from '@/api/payment';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import PaymentModal from '@/components/common/Modal/PaymentModal/PaymentModal';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';

import * as S from './style';

const PublicationArticlePayment = () => {
	dayjs.locale('ko');

	const { showModal } = useModalStore();
	const { isLogin } = useTokenStore();
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const params = location.state?.menu ?? '게재료 결제';
	const { data: payInfo } = useGetPayInfoApi();
	const memberType = payInfo?.member_type;

	const handleRegister = async () => {
		if (!isLogin()) {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}

		setIsOpen(true);
	};

	const handleConfirm = () => {
		if (isLogin()) {
			navigate({
				pathname: '/publication',
				search: createSearchParams({ menu: params, step: '등록 확인' }).toString(),
			});
		} else {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}
	};

	return (
		<S.Container>
			<S.ContentBox>
				<S.ContentTitle>게재료 관련 안내 내용</S.ContentTitle>
				<S.BasicInfoButtonBox>
					<S.BlueButton type="button" onClick={handleRegister}>
						결제
						<SingleArrowNext iconColor="#FFFFFF" width="20" height="20" />
					</S.BlueButton>
					<S.WhiteButton type="button" onClick={handleConfirm}>
						결제 확인
						<SingleArrowNext iconColor="#12539E" width="20" height="20" />
					</S.WhiteButton>
				</S.BasicInfoButtonBox>
				<S.ContentDescription>
					<li>논문 게재료는 논문 게재 후 학회 사무국에서 안내드린 후 결제가 가능합니다.</li>
					<li>논문 게재료는 1편당 400,000원이며 속보(급행)인 경우 600,000원 입니다.</li>
					<li>건별로 진행되며, 논문 2편에 대한 결제가 필요한 경우 각각 진행 부탁드립니다.</li>
				</S.ContentDescription>
			</S.ContentBox>
			<S.ContentBox>
				<S.ContentBox>
					<S.ContentTitle>게재료 비용 안내</S.ContentTitle>
					<S.Table>
						<S.TableHeadCell className="item2 center">구분</S.TableHeadCell>
						<S.TableHeadCell className="center">게재료 비용</S.TableHeadCell>

						<S.TableCell className="item3 point center">1편당</S.TableCell>
						<S.TableCell className="min-height point center">기본</S.TableCell>
						<S.TableCell className="min-height center">400,000원</S.TableCell>

						<S.TableCell className="min-height point center">속보(급행)</S.TableCell>
						<S.TableCell className="min-height center">600,000원</S.TableCell>
					</S.Table>
				</S.ContentBox>
			</S.ContentBox>
			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<PaymentModal closeModal={setIsOpen} goodsName="게재료" memberType={memberType} />
					</ModalBox>
				</ModalPortal>
			)}
		</S.Container>
	);
};

export default PublicationArticlePayment;
